import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SelectInput from "../../SelectInput/index";
import { cloneDeep, isEqual } from 'lodash';
import { updateConfig } from '@/api/configurationlist';
export default {
  props: ["deviceDid", "deviceSn", 'IpList'],
  components: {
    SelectInput: SelectInput
  },
  data: function data() {
    return {
      dialogVisible: false,
      DialogFromData: {},
      protocolList: [{
        value: 'tcp udp',
        label: 'TCP+UDP'
      }, {
        value: 'tcp',
        label: 'TCP'
      }, {
        value: 'udp',
        label: 'UDP'
      }, {
        value: 'other',
        label: this.$t('lang.port.other')
      }],
      wanList: [{
        value: 'wan',
        label: 'wan'
      }],
      lanList: [{
        value: 'lan',
        label: 'lan'
      }],
      index: 0,
      originalData: {}
    };
  },
  methods: {
    show: function show(item, index) {
      this.DialogFromData = cloneDeep(item);
      this.DialogFromData.reflection = this.DialogFromData.reflection == '0' ? false : true;
      this.dialogVisible = true;
      this.index = index;
      this.originalData = cloneDeep(this.DialogFromData);
    },
    //启用禁用
    OnOff: function OnOff() {
      this.DialogFromData.enabled = this.DialogFromData.enabled == '' ? true : false;
    },
    //修改源Ip地址
    Src_ipSelectInput: function Src_ipSelectInput(props) {
      this.DialogFromData.src_ip = props;
    },
    //修改外部Ip地址
    Src_dipSelectInput: function Src_dipSelectInput(props) {
      // console.log(props)
      this.DialogFromData.src_dip = props;
    },
    //修改内部Ip地址
    Dest_ipSelectInput: function Dest_ipSelectInput(props, index) {
      console.log(props, index);

      if (index == undefined) {
        this.DialogFromData.dest_ip = props;
      } else {
        this.data[index].options.dest_ip = props;
      }
    },
    editRedirect: function editRedirect() {
      var _this = this;

      if (!isEqual(this.DialogFromData, this.originalData)) {
        // 0是禁用，其他的是开启
        var dataCopy = cloneDeep(this.DialogFromData);
        dataCopy.enabled = dataCopy.enabled == true ? '1' : '0';
        dataCopy.reflection = dataCopy.reflection == true ? '1' : '0';
        var data = [{
          section: "redirect",
          config: "firewall",
          action: 0,
          index: [this.index],
          server: "firewall",
          options: _objectSpread({}, dataCopy)
        }];
        console.log(data);
        updateConfig(this.deviceSn, this.deviceDid, data).then(function (res) {
          if (res.data.data.mess === 0) {
            _this.$message({
              showClose: true,
              message: _this.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: 'success'
            });

            _this.$emit('updateData');

            _this.dialogVisible = false;
          } else {
            _this.$message({
              showClose: true,
              message: _this.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });
          }
        });
      } else {
        this.dialogVisible = false;
      }
    }
  }
};